export default {
  'supportlink':'<a href="mailto:support@familyandco.com">support@familyandco.com</a>',
  'termslink':'<a href="terms.html">${nc.terms}</a>',
  'privacylink':'<a href="privacy.html">${nc.privacy}</a>',
  'signuplink':'<a href="fw2_signup.php" data-ga-event="Signin|Switch_To_Signup|Switch_To_Signup">${nc.signup.link}</a>',
  'signinlink':'<a href="fw2_signin.php">${nc.signin.link}</a>',
  'inviteesignuplink':'<a href="fw2_invitation.php" data-ga-event="Signin|Switch_To_Signup|Switch_To_Signup">${nc.signup.link}</a>',
  'inviteesigninlink':'<a href="fw2_signin.php" data-ga-event="Join|Switch_To_Login|Switch_To_Login">${nc.signin.link}</a>',
  'hellotime':function(){
    var hour = new Date().getHours();
    if(hour>4 && hour<=12){
      return '${hello.goodmorning}';
    }else if(hour<=19){
      return '${hello.goodafternoon}';
    }else{
      return '${hello.goodevening}';
    }
  }
};